import type { ApiResponse } from './estClient';

import { cache } from '../cache';
import { estClient } from './estClient';
import { httpClient } from './httpClient';

export interface WepsterConfig {
  wepster: { isEnabled: boolean; businessId: string; token: string };
  viber: { canWriteFirst: boolean };
  telegram: { canWriteFirst: boolean; token: string };
  whatsapp: {
    canWriteFirst: boolean;
    token: string;
    templateName: string;
    templateLanguageCode: string;
  };
  alphasms: { canWriteFirst: boolean; token: string; alphasmsPageId: string };
  echat: { canWriteFirst: boolean; token: string };
  facebook: { canWriteFirst: boolean };
  instagram: { canWriteFirst: boolean };
  vkontakte: { canWriteFirst: boolean };
}

export type WepsterConfigResponse = ApiResponse<{
  wepster_config: WepsterConfig;
}>;

interface WepsterAddContactResponse {
  wepster_id: string;
  message: 'Contact added successfully.';
}

class WepsterApi {
  async get(): Promise<WepsterConfig> {
    const resp = await estClient.get<WepsterConfigResponse>(
      '/api/wepster/config',
    );

    return resp.wepster_config;
  }

  getCached(): Promise<WepsterConfig> {
    return cache.get('wepster-config', async () => this.get());
  }

  async save(body: WepsterConfig): Promise<WepsterConfig> {
    const resp = await estClient.post<WepsterConfigResponse>(
      '/api/wepster/config',
      {
        body,
      },
    );

    return resp.wepster_config;
  }

  /**
   * Sends contact creation request via wepster api
   *
   * @see https://estoffice.notion.site/Add-contact-POST-new-de7239128955419585a82870c1f066f4
   */
  addContact(body: {
    connectionId: string;
    channelType: string;
    name: string;
    phone: string;
    templateName?: string;
    templateLanguageCode?: string;
  }): Promise<WepsterAddContactResponse> {
    return httpClient.post<WepsterAddContactResponse>(
      'https://my.wepster.com/api/v1/contact/add',
      {
        body,
      },
    );
  }
}

export const wepsterApi = new WepsterApi();
